<div class="container m-b-20 layout-row align-end gap-20px">
  <button mat-raised-button color="primary" [routerLink]="['edit']" *LOSxHasPermission="'UPDATE_ACCOUNTNUMBERFORMAT'">
    <fa-icon icon="edit" class="m-r-10"></fa-icon>
    {{ 'labels.buttons.Edit' | translate }}
  </button>

  <button mat-raised-button color="warn" (click)="delete()" *LOSxHasPermission="'DELETE_ACCOUNTNUMBERFORMAT'">
    <fa-icon icon="trash" class="m-r-10"></fa-icon>
    {{ 'labels.buttons.Delete' | translate }}
  </button>
</div>

<div class="container">
  <mat-card>
    <mat-card-content>
      <div class="layout-row-wrap">
        <div class="flex-50 mat-body-strong">
          {{ 'labels.inputs.Account Type' | translate }}
        </div>

        <div class="flex-50">
          {{ accountNumberPreferenceData.accountType.value | translateKey: 'catalogs' }}
        </div>

        @if (accountNumberPreferenceData.prefixType) {
          <div class="flex-50 mat-body-strong">
            {{ 'labels.inputs.Prefix Type' | translate }}
          </div>
        }

        @if (accountNumberPreferenceData.prefixType) {
          <div class="flex-50">
            {{ accountNumberPreferenceData.prefixType.value }}
          </div>
        }
      </div>
    </mat-card-content>
  </mat-card>
</div>
